import { render, staticRenderFns } from "./parainput.vue?vue&type=template&id=1f5d7307&scoped=true&"
import script from "./parainput.vue?vue&type=script&lang=js&"
export * from "./parainput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d7307",
  null
  
)

export default component.exports